import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { CheckCircle, Sparkles, TrendingUp } from 'lucide-react';
export function BeneficiosSection() {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start center', 'end center']
  });
  const benefits = [{
    id: 1,
    icon: <CheckCircle className="w-8 h-8 text-[#22C55E]" style={{
      filter: 'drop-shadow(0 0 8px rgba(34, 197, 94, 0.6))'
    }} data-id="element-1" />,
    title: <>
          TE{' '}
          <span className="text-[#22C55E] font-black" style={{
        textShadow: '0 0 20px rgba(34, 197, 94, 0.5)'
      }} data-id="element-2">
            CUMPLIRÁS
          </span>
          , INCLUSO CUANDO NO TENGAS GANAS.
        </>,
    description: 'El sistema visual te mostrará la verdad todos los días: lo hiciste o no lo hiciste. Sin excusas, sin autoengaños.'
  }, {
    id: 2,
    icon: <TrendingUp className="w-8 h-8 text-[#22C55E]" style={{
      filter: 'drop-shadow(0 0 8px rgba(34, 197, 94, 0.6))'
    }} data-id="element-3" />,
    title: <>
          RECUPERARÁS LA{' '}
          <span className="text-[#22C55E] font-black" style={{
        textShadow: '0 0 20px rgba(34, 197, 94, 0.5)'
      }} data-id="element-4">
            CONFIANZA
          </span>{' '}
          EN TI MISMO.
        </>,
    description: 'Cada hábito cumplido reconstruirá tu palabra personal y volverás a creer en lo que dices que vas a hacer.'
  }, {
    id: 3,
    icon: <Sparkles className="w-8 h-8 text-[#22C55E]" style={{
      filter: 'drop-shadow(0 0 8px rgba(34, 197, 94, 0.6))'
    }} data-id="element-5" />,
    title: <>
          TOMARÁS{' '}
          <span className="text-[#22C55E] font-black" style={{
        textShadow: '0 0 20px rgba(34, 197, 94, 0.5)'
      }} data-id="element-6">
            CONTROL REAL
          </span>{' '}
          DE TU TIEMPO Y TUS DECISIONES.
        </>,
    description: 'Dejarás el caos mental y verás con claridad qué hacer y cuándo hacerlo. Para que este 2026 sí sea diferente.'
  }];
  return <section id="beneficios" className="py-24 bg-[#0A0A0A] relative overflow-hidden" ref={containerRef} data-id="element-7">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-8">
        <div className="text-center mb-16" data-id="element-9">
          <h2 className="text-3xl md:text-4xl font-black text-white uppercase tracking-tight mb-4" data-id="element-10">
            Qué lograrás con este{' '}
            <span className="text-[#22C55E]" style={{
            textShadow: '0 0 20px rgba(34, 197, 94, 0.4)'
          }} data-id="element-11">
              sistema visual
            </span>
          </h2>
          <div className="w-24 h-1 bg-[#22C55E] mx-auto rounded-full" style={{
          boxShadow: '0 0 10px #22C55E'
        }} data-id="element-12"></div>
        </div>

        <div className="relative grid grid-cols-[auto_1fr] gap-6 md:gap-16" data-id="element-13">
          {/* Progress Rail - Green */}
          <div className="relative w-1 bg-gray-800 rounded-full h-full min-h-[400px] ml-2 md:ml-4" data-id="element-14">
            <motion.div className="absolute top-0 left-0 w-full bg-[#22C55E] rounded-full" style={{
            height: useTransform(scrollYProgress, [0, 1], ['0%', '100%']),
            boxShadow: '0 0 10px #22C55E, 0 0 20px rgba(34, 197, 94, 0.5)'
          }} data-id="element-15" />
          </div>

          {/* Cards Container */}
          <div className="space-y-12" data-id="element-16">
            {benefits.map((benefit, index) => <motion.div key={benefit.id} initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="bg-[#121212] border border-white/5 p-8 rounded-2xl hover:border-[#22C55E]/30 transition-colors duration-300 group" data-id="element-17">
                <div className="flex flex-col sm:flex-row gap-6 items-start" data-id="element-18">
                  <div className="p-4 bg-black rounded-xl border border-white/10 group-hover:border-[#22C55E]/50 transition-colors" data-id="element-19">
                    {benefit.icon}
                  </div>
                  <div data-id="element-20">
                    <p className="text-xl md:text-2xl text-white font-bold leading-relaxed uppercase tracking-tight mb-3" data-id="element-21">
                      {benefit.title}
                    </p>
                    <p className="text-base text-gray-400 leading-relaxed normal-case" data-id="element-22">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}